import TableBodyCell from 'components/common/Table/TableBodyCell/TableBodyCell';
import TableRow from 'components/common/Table/TableRow/TableRow';
import { DeleteIcon, EditIcon } from 'components/common/Icons/Icons';
import { RoleDialogType } from 'components/roles/roles.enums';
import { RoleDto } from 'components/roles/roles.dto';

import styles from './RoleItem.module.scss';

interface RoleItemProps {
  role: RoleDto;
  onOpenDialog: (dialogType: RoleDialogType, role: RoleDto) => void;
}

const RoleItem = ({ role, onOpenDialog }: RoleItemProps) => {
  return (
    <TableRow className={styles.tableColumnsWithButtons} onClick={() => onOpenDialog(RoleDialogType.View, role)}>
      <div className={styles.tableRowTemplate}>
        <TableBodyCell>{role.name}</TableBodyCell>
      </div>
      <TableBodyCell>
        <div className={styles.actionButtons}>
          {!role.isDefault && (
            <EditIcon
              onClick={(event: any) => {
                event.stopPropagation();
                onOpenDialog(RoleDialogType.Edit, role);
              }}
            />
          )}
          {!role.isDefault && (
            <DeleteIcon
              onClick={(event: any) => {
                event.stopPropagation();
                onOpenDialog(RoleDialogType.Delete, role);
              }}
            />
          )}
        </div>
      </TableBodyCell>
    </TableRow>
  );
};

export default RoleItem;
